import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * Breadcrumb nav for hierarchical pages. Pass items as array of {label, to?}.
 * Last item is always non-clickable (current page).
 */
export default function Breadcrumb({ items = [], testid = "breadcrumb" }) {
  if (!items.length) return null;
  return (
    <nav aria-label="Breadcrumb" data-testid={testid} className="flex items-center flex-wrap gap-1 text-xs text-[#4B5563]">
      <Link to="/" className="inline-flex items-center gap-1 hover:text-[#1E3A8A] transition-colors" data-testid={`${testid}-home`}>
        <Home size={12} /> Beranda
      </Link>
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <React.Fragment key={i}>
            <ChevronRight size={12} className="text-[#4B5563]/50" />
            {last || !it.to ? (
              <span className="text-[#1F2937] font-medium" data-testid={`${testid}-crumb-${i}`}>{it.label}</span>
            ) : (
              <Link to={it.to} className="hover:text-[#1E3A8A] transition-colors" data-testid={`${testid}-crumb-${i}`}>{it.label}</Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
